(function() {

    var ecommerceProducts = document.querySelectorAll('[OBJ009]');

    if (ecommerceProducts) {
        for (var index = 0; index < ecommerceProducts.length; index++) {
            ecommerceProducts[index].addEventListener('click', OBJ009);
        }
    }

    function OBJ009(e) {
        e.preventDefault();
        var OBJ009 = this.getAttribute('OBJ009');
        OBJ009 = JSON.parse(OBJ009);

        var name = OBJ009.type + '_' + OBJ009.title;
        var id = OBJ009.type + '_' + OBJ009.date + '_' + OBJ009.title;

        dataLayer.push({
            "object": {
                "Id": "OBJ009",
                "name": OBJ009.type + " - Click"
            },
            "event": "ecommerceAction",
            "ecommerce": {
                "currencyCode": "CAD",
                "click": {
                    "actionField": {
                        "list": OBJ009.list
                    },
                    "products": [{
                        "name": name.trim(),
                        "id": id,
                        "price": "1",
                        "brand": "createch canada",
                        "category": OBJ009.category,
                        "variant": OBJ009.author,
                        "position": OBJ009.position
                    }]
                }
            }
        });

    }
})();
